import React, { useState, useEffect, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import store from 'store/store';
import { AxiosGeneral as Axios, AxiosErrorHandling } from "connection/Axios"
import PropagateLoader from "react-spinners/PropagateLoader";
import { Row, Col, Card } from 'react-bootstrap'
import * as IconsBi from "react-icons/bi";
import Admin_Dashbord from "./Admin";
import Operator_Dashbord from "./Operator";
import Media_Dashbord from "./Media";

function Dashboard(props) {
    const state = store.getState()
    const [data, setData] = useState([]);
    
    useEffect(() => {
        store.dispatch({ type: 'START_LOADING' });
        getData()
    }, [,props.re_render])

    const getData = () => {
        Axios.post('/dashboard')
        .then(async (res) => {
            // console.log('dashboard:',res.data.data)
            setData(res.data.data)
        })
        .catch((err) => {
            // console.log('err:',err)
        })
        .finally(() => {
            store.dispatch({ type: 'STOP_LOADING' });
        })
    }

    return (
        <>
            {
                state.loading
                ?
                    <PropagateLoader color="#36d7b7" className="d-flex aligns-items-center justify-content-center" />
                :
                    <>
                        {
                            // (state?.user?.type?.includes('admin') && data?.pattern !== undefined) &&
                            data?.pattern !== undefined &&
                            <Admin_Dashbord data={data.admin} pattern={data.pattern} patterns={data.patterns} tags={data.tags} />
                        }
                        {/* {
                            (!state?.user?.type?.includes('admin') && state?.user?.type?.includes('operator')) &&
                            <Operator_Dashbord data={data.operator} />
                        }
                        {
                            state?.user?.type?.includes('operator') &&
                            <Operator_Dashbord data={data.operator} />
                        }
                        {
                            state?.user?.type?.includes('media') &&
                            <Media_Dashbord data={data.media} state={state} />
                        } */}
                    </>
            }
        </>
    )
}


const mapStateToProps = (state) => {
    return {
        loading: state.loading
    };
}

export default connect(mapStateToProps)(Dashboard);